import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import * as _ from 'lodash';
import {SimpleListEditableComponent} from "./simple-list-editable.component";

export interface ISimplelistItem {
    item: any;
    index: number;
    selected: boolean;
}

@Component({
    selector: 'app-simple-list',
    templateUrl: './simple-list.component.html',
    styleUrls: ['./simple-list.component.scss']
})
export class SimpleListComponent implements OnInit {

    m_icon;
    m_iconCallback: ((a: number, b: any) => string);
    m_iconInstanceOfFunction: boolean;
    m_editing = false;
    m_iconSelected = '';
    m_iconSelectedIndex = -1;
    m_iconSelectedMode = false;
    m_metadata: any = {};
    // faCircle = faCircle;
    // faCheckCircle = faCheckCircle;

    @ViewChild(SimpleListEditableComponent)
    simplelistEditable: SimpleListEditableComponent;

    @Input() filter = '';
    @Input() list;

    @Input()
    editable = false;

    @Input()
    tooltip = '';

    @Input()
    content: ((any) => string);

    @Input()
    contentId: ((any) => string);

    @Input()
    multiSelect = true;

    @Input()
    iconSelected: ((index: number, item: any) => boolean);

    @Input()
    set icon(i_icon: any) {
        this.m_icon = i_icon;
    }

    @Input()
    set iconCallback(i_iconCallback: ((a: number, b: any) => string)) {
        this.m_iconCallback = i_iconCallback;
    }

    @Input()
    set iconSelectiondMode(mode: boolean) {
        if (mode) {
            this.m_iconSelectedMode = true;
            this.m_icon = 'gps_not_fixed';
            this.m_iconSelected = 'gps_fixed';
        }
    }

    // @Output()
    // hover: EventEmitter<any> = new EventEmitter();

    @Output()
    iconClicked: EventEmitter<any> = new EventEmitter();

    @Output()
    itemClicked: EventEmitter<any> = new EventEmitter();

    @Output()
    selected: EventEmitter<any> = new EventEmitter();

    @Output()
    edited: EventEmitter<any> = new EventEmitter();

    constructor(public cd: ChangeDetectorRef) {
    }

    ngOnInit() {
    }

    /**
     constructor(public cd: ChangeDetectorRef, public _ngZone: NgZone, public el: ElementRef) {}

     worked on canceling scroll event
     ngOnInit() {
        this._ngZone.runOutsideAngular(() => {
            const nativeElement = this.el.nativeElement;
            this._handler = $event => {
                $event.stopImmediatePropagation();
                $event.preventDefault();
                // this.emitter.emit($event);
                return false;
            }
            nativeElement.addEventListener('mousewheel', this._handler, false);
            nativeElement.addEventListener('DOMMouseScroll', this._handler, false);
            nativeElement.addEventListener('onmousewheel', this._handler, false);
        });
    }

     @Output('outSideEventHandler')
     emitter = new EventEmitter();

     public _handler: Function;
     **/


    // public m_metadata: { [key: string]: IsimplelistItem } = {};

    // ngAfterViewInit() {
    // if (this.simplelistEditable)
    //     this.simplelistEditable.setContent(this.content)
    // }




    public onEditChanged(event) {
        this.edited.emit((event));
    }

    public itemSelected(item, index) {
        this.itemClicked.emit({
            item,
            index
        });
        // tslint:disable-next-line
        let id = this.contentId ? this.contentId(item) : index;
        // tslint:disable-next-line
        for (let id in this.m_metadata) {
            this.m_metadata[id] = {
                selected: false
            };
        }
        this.m_metadata[id] = {
            item,
            index,
            selected: true // this.m_editClickPending ? true : !this.m_metadata[id].selected

        };
        this.selected.emit(this.m_metadata);
    }

    public renderIcon(index, item) {
        if (this.m_iconSelectedMode) {
            if (this.iconSelected) {
                if (this.iconSelected(index, item)) {
                    this.m_iconSelectedIndex = index;
                    return this.m_iconSelected;
                } else {
                    return this.m_icon;
                }
            }
            if (index == this.m_iconSelectedIndex)
                return this.m_iconSelected;
            return this.m_icon;
        } else {
            if (!this.m_iconInstanceOfFunction)
                this.m_iconInstanceOfFunction = (this.m_iconCallback instanceof Function);
            if (this.m_iconInstanceOfFunction) {
                return this.m_iconCallback(index, item);
            }
            return this.m_icon;
        }
    }

    public itemAllSelected() {
        if (!this.multiSelect)
            return;
        // tslint:disable-next-line
        for (let id in this.m_metadata)
            this.m_metadata[id].selected = true;
        this.list.forEach((i_item) => {
            this.selected.emit(this.m_metadata);
        });
    }

    public setItemSelected(cb: (a, b) => boolean) {
        // this.deselect();
        // tslint:disable-next-line
        for (let id in this.m_metadata) {
            // tslint:disable-next-line
            if (cb(id, this.m_metadata[id])) {
                this.m_metadata[id].selected = true;
            } else {
                this.m_metadata[id].selected = false;
            }
        }
        //     if (this.m_metadata[id] === item) {
        //         this.m_metadata[id].selected = true;
        //         this.selected.emit(this.m_metadata);
        //     }
        // }
    }

    public onIconClick(event, index) {
        // this.m_editClickPending = true;
        this.m_iconSelectedIndex = index;
        setTimeout(() => {
            const match = _.find(this.m_metadata, (i: any) => i.index === index);
            this.iconClicked.emit({
                item: match,
                target: event.target,
                index,
                metadata: this.m_metadata
            });
        }, 1);
        return true;
    }

    public getMetadata(index, item) {
        const id = this.contentId ? this.contentId(item) : index;
        return this.m_metadata[id];
    }

    public isActive(index, item) {
        const id = this.contentId ? this.contentId(item) : index;
        if (this.m_metadata[id]?.selected) return true;
        return false;
    }

    public setContent(f) {
        this.content = f;
        // this.simplelistEditable.setContent(this.content)
    }

    public getContentId(item, index): string {
        const id = this.contentId ? this.contentId(item) : index;
        if (!this.m_metadata[id])
            this.m_metadata[id] = {};
        this.m_metadata[id].index = index;
        return id;
    }

    public getContent(item): string {
        if (this.content) {
            return this.content(item);
        } else {
            return item;
        }
    }

    public deselect() {
        this.itemSelected(null, -1);
        this.cd.markForCheck();
    }

    public getSelected(): ISimplelistItem | { [key: string]: ISimplelistItem } {
        if (this.multiSelect)
            return this.m_metadata;
        for (const v in this.m_metadata) {
            if (this.m_metadata[v].selected == true)
                return this.m_metadata[v];
        }
    }

    public set selectedIconIndex(i_index) {
        this.m_iconSelectedIndex = i_index;
    }

    public get selectedIconIndex() {
        return this.m_iconSelectedIndex;
    }

    public get selectedIconIndexItem(): ISimplelistItem {
        let r: ISimplelistItem;
        Object.keys(this.m_metadata).find((a) => {
            if (this.m_metadata[a].index === this.m_iconSelectedIndex) {
                return r = {item: a, index: this.m_metadata[a].index, selected: this.m_metadata[a].selected};
            }
        });
        return r;
    }
}
